module.exports = __webpack_public_path__ + "img/GTM-integration-vidjet-step6-ES.6c8bef8d.png";